export default __webpack_public_path__ + "static/media/navCloseIcon.78ef4bea.svg";